// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"d0f88271","167":"85965e72","351":"d118384d","666":"9b74bca3","727":"d1a56f41","747":"d18d9847","955":"b92c0ca0","982":"a37dfbe6"}[chunkId] + ".chunk.js";
};